/**
 * Copy — confirmación de correo tras invitación de equipo (portal + app negocio).
 * Voz: documentacion/design/brand/VOICE.md (vos, oraciones cortas).
 */

export const employeeInvitationEmailConfirmCopy = {
  /** Portal `/invitacion/exito` — alta con contraseña, mail de confirmación disparado */
  portalExitoConfirm: {
    kicker: 'Un paso más',
    title: 'Confirmá tu correo',
    body: (email: string) =>
      `Te mandamos un enlace a ${email}. Abrilo y después entrá a Vuelto con ese mismo correo y la contraseña que elegiste.`,
    spamHint: 'Si no lo ves, mirá spam y promociones.',
    resendCta: 'Reenviar enlace',
    resendSending: 'Reenviando…',
    openAppCta: 'Abrir Vuelto',
    openAppHint: 'Entrá con el mismo correo y la contraseña de la invitación.',
    resendSuccess: 'Listo. Revisá tu correo; puede tardar un minuto.',
    resendError: 'No pudimos reenviar el enlace. Probá de nuevo en un momento.',
    backLink: 'Volver',
  },

  /** Portal `/invitacion/exito` — Google / Apple u otra cuenta ya verificada */
  portalExitoReady: {
    kicker: 'Listo',
    title: 'Ya sos parte del equipo',
    body: 'Entrá a Vuelto con el mismo correo (o el mismo Google) que usaste acá. Ahí vas a ver el local.',
    reloginHint: 'Si ya tenías la app abierta, cerrá sesión y volvé a entrar.',
    openAppCta: 'Abrir Vuelto e ingresar',
    backLink: 'Volver',
  },

  /** App negocio — pantalla post-signup o login bloqueado por mail sin confirmar */
  negocioPending: {
    title: 'Confirmá tu correo',
    subtitle: (email: string) =>
      `Te mandamos un enlace a ${email}. Abrilo y volvé a ingresar. Mirá también spam.`,
    resendCta: 'Reenviar enlace',
    resendSuccessTitle: 'Enlace reenviado',
    resendSuccessBody: 'Revisá tu correo. Puede tardar un minuto.',
    backCta: 'Ya lo confirmé — Ingresar',
  },
} as const;
